import { NormalizedNumber, Percentage } from '@sparkdotfi/common-universal'

import { formatPercentage } from '@/domain/common/format'
import { Token } from '@/domain/types/Token'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { links } from '@/ui/constants/links'
import { Alert } from '@/ui/molecules/alert/Alert'

export interface StusdsWarningProps {
  underlyingToken: Token
  lockstakeDebt: NormalizedNumber
  totalAssets: NormalizedNumber
}
export function StusdsWarning({ underlyingToken, lockstakeDebt, totalAssets }: StusdsWarningProps) {
  if (totalAssets.gte(lockstakeDebt)) {
    return null
  }

  const fillPercentage = Percentage(totalAssets.div(lockstakeDebt), { allowMoreThan1: true })

  return (
    <Alert variant="error">
      Until deposits exceed {underlyingToken.format(lockstakeDebt, { style: 'compact' })} USDS, withdrawals may be
      temporarily unavailable.{' '}
      <span className="whitespace-nowrap">
        Current deposits: {underlyingToken.format(totalAssets, { style: 'compact' })}/
        {underlyingToken.format(lockstakeDebt, { style: 'compact' })} (
        {formatPercentage(fillPercentage, { minimumFractionDigits: 2 })} filled).
      </span>{' '}
      <span className="whitespace-nowrap">
        <ExternalLink to={links.docs.savings.stusds} variant="underline">
          Learn more
        </ExternalLink>
      </span>
    </Alert>
  )
}
